import { createIcon } from './factory'
import Icon from './user-plus.svg?react'

export const UserPlus = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
